var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("validation-observer", {
        ref: "accountNumbers",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ failed }) {
              return [
                _c("div", { staticClass: "p-3 row", class: [_vm.bgColor] }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm mb-4" },
                    [
                      _c("div", { staticClass: "label mb-2" }, [
                        _vm._v("Tipo de Cifra:")
                      ]),
                      !_vm.isReadOnly
                        ? _c("validation-provider", {
                            attrs: {
                              name: `accountNumber-accountNumber-${Math.random()}`,
                              rules: `${
                                _vm.required || _vm.hasValidate
                                  ? "required"
                                  : ""
                              }`
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          id: `isFederal`,
                                          "custom-error-msg":
                                            "El tipo de cifra es requerido.",
                                          error: errors[0],
                                          fieldkey: "id",
                                          fieldname: "name",
                                          options: _vm.accountTypes,
                                          placeholder: "Seleccione"
                                        },
                                        model: {
                                          value: _vm.accountType,
                                          callback: function($$v) {
                                            _vm.accountType = $$v
                                          },
                                          expression: "accountType"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _c("div", [_vm._v(_vm._s(_vm.value.accountTypeName))])
                    ],
                    1
                  ),
                  _vm.isFederal || _vm.isReadOnly
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-sm mb-4" },
                        [
                          _c("div", { staticClass: "label mb-2" }, [
                            _vm._v("Grupo de Edad:")
                          ]),
                          !_vm.isReadOnly
                            ? _c("validation-provider", {
                                attrs: {
                                  name: `accountNumber-accountNumber-${Math.random()}`,
                                  rules: `${
                                    _vm.required || _vm.hasValidate
                                      ? "required"
                                      : ""
                                  }`
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              id: `billingServiceCategory`,
                                              "custom-error-msg":
                                                "El grupo de edad es requerido.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              options:
                                                _vm.billingServiceCategories,
                                              placeholder: "Seleccione"
                                            },
                                            model: {
                                              value: _vm.billingServiceCategory,
                                              callback: function($$v) {
                                                _vm.billingServiceCategory = $$v
                                              },
                                              expression:
                                                "billingServiceCategory"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isFederal
                                        ? _vm.value.billingServiceCategoryName
                                        : "N/A"
                                    ) +
                                    " "
                                )
                              ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm mb-4" },
                    [
                      _c("div", { staticClass: "label mb-2" }, [
                        _vm._v("Cifra de Cuenta:")
                      ]),
                      !_vm.isReadOnly
                        ? _c("validation-provider", {
                            attrs: {
                              name: `accountNumber-accountNumber-${Math.random()}`,
                              rules: `${
                                _vm.required || _vm.hasValidate
                                  ? "required"
                                  : ""
                              }`
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          id: `reason`,
                                          "custom-error-msg":
                                            "La cifra de cuenta es requerida.",
                                          error: errors[0],
                                          fieldkey: "purchaseOrderNumberId",
                                          fieldname: "fullNumber",
                                          options: _vm.filteredAccountNumbers,
                                          placeholder: "Seleccione"
                                        },
                                        model: {
                                          value: _vm.accountNumber,
                                          callback: function($$v) {
                                            _vm.accountNumber = $$v
                                          },
                                          expression: "accountNumber"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _c("div", [_vm._v(_vm._s(_vm.value.fullNumber))])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-2 mb-4" },
                    [
                      _c("div", { staticClass: "label mb-2" }, [
                        _vm._v("Monto:")
                      ]),
                      !_vm.isReadOnly
                        ? _c("validation-provider", {
                            staticClass: "input",
                            attrs: {
                              name: `accountNumber-amount`,
                              rules: `${
                                _vm.hasValidate || _vm.required
                                  ? "required|"
                                  : ""
                              }money|differentFromZero|greaterThanZero`
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        attrs: {
                                          "custom-error-msg":
                                            "El monto es requerido.",
                                          error: errors[0],
                                          "mask-type": "Money"
                                        },
                                        model: {
                                          value: _vm.amount,
                                          callback: function($$v) {
                                            _vm.amount = $$v
                                          },
                                          expression: "amount"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _c("div", [
                            _vm._v(_vm._s(_vm._f("price")(_vm.value.amount)))
                          ])
                    ],
                    1
                  ),
                  _vm.isReadOnly && _vm.canRemove
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-md-2 mb-4 d-md-flex align-items-center justify-content-md-end"
                        },
                        [
                          _c("action-button", {
                            staticClass:
                              "outline-danger py-1 custom-action-button",
                            attrs: { i: "fa fa-times-circle" },
                            on: { click: _vm.remove }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isReadOnly
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row col-12 col-md-12 d-md-flex align-items-center justify-content-md-end p-0",
                          class: failed ? "mb-4" : ""
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-6 col-md-2" },
                            [
                              _c(
                                "action-button",
                                {
                                  staticClass: "outline-danger py-1 w-100",
                                  attrs: { i: "fa fa-times-circle" },
                                  on: { click: _vm.cancel }
                                },
                                [_vm._v(" Cancelar ")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6 col-md-2 p-0" },
                            [
                              _c(
                                "action-button",
                                {
                                  staticClass: "success py-1 w-100",
                                  attrs: { i: "fas fa-file-plus" },
                                  on: { click: _vm.add }
                                },
                                [_vm._v(" Añadir ")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }